import * as React from "react"
import {
  PermissionsResource,
  PermissionsCheck,
  PermissionsCheckProps,
} from "@modules/permissions"
import { useSitePermissionsQuery } from "@modules/site/shared/queries.generated"

type SitePermissionsResource = Extract<
  PermissionsResource,
  "sites" | "contributor"
>

export type SitePermissionsProps<T extends SitePermissionsResource> = Omit<
  PermissionsCheckProps<T>,
  "digest"
> & {
  id: string
}

export function SitePermissions<T extends SitePermissionsResource>({
  id,
  ...rest
}: SitePermissionsProps<T>) {
  const { data } = useSitePermissionsQuery({
    variables: { id },
  })

  const permissions = data?.siteDetails?.permissions ?? null

  return <PermissionsCheck digest={permissions} {...rest} />
}
